import { Locale } from "@redotech/crdb-enums/common/locale";
import { TranslatableInstructionMethodSchema } from "@redotech/redo-return-settings-common/packing-instruction-return-method";
import * as z from "zod";

const ReturnInstructionTranslationSetSchema_ = z.object({
  instructionSet: TranslatableInstructionMethodSchema,
  sourceInstructions: z.array(z.string()),
  /** Merchant-approved translations only. */
  translations: z.array(
    z.object({
      locale: z.enum(Locale),
      instructions: z.array(z.string()),
      /** Approved for instructions the merchant has since changed. */
      stale: z.boolean(),
    }),
  ),
});
export const ReturnInstructionTranslationSetSchema: z.ZodType<ReturnInstructionTranslationSetSchema> =
  ReturnInstructionTranslationSetSchema_;
export interface ReturnInstructionTranslationSetSchema extends z.infer<
  typeof ReturnInstructionTranslationSetSchema_
> {}
